module.exports = __webpack_public_path__ + "static/media/04-MGM_Casino_Fish_Restaurant.3fd4bd8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mgm-casino/04-MGM_Casino_Fish_Restaurant.jpg
// module id = 1189
// module chunks = 37